import { FC, useMemo } from "react";
import { GetAdminEmailTemplatesResult_EmailTemplate, PaginatedRequest } from "tech-health-assessment-sdk/dist";
import { BodyCard } from "../../../../common/components/body-card/body-card";
import { StandardCardGridContainer } from "../../../../common/components/standard-card-grid-container/standard-card-grid-container";
import { StandardCardHeader, StandardCardHeaderLoadingState } from "../../../../common/components/standard-card-header/standard-card-header";
import { StandardCardLayout } from "../../../../common/components/standard-card-layout/standard-card-layout";
import { Grid, GridLoadingState } from "../../../../common/grid/grid";
import { columns } from "./admin-email-templates-grid-card.columns";

type AdminEmailTemplatesGridCardProps = {
    emailTemplates: GetAdminEmailTemplatesResult_EmailTemplate[]
    pagination: PaginatedRequest
    onPaginationChange: (pagination: PaginatedRequest) => void
    totalCount: number
}

export const AdminEmailTemplatesGridCard: FC<AdminEmailTemplatesGridCardProps> = ({
    emailTemplates,
    pagination,
    onPaginationChange,
    totalCount,
}) => {

    // constants
    const memoizedColumns = useMemo(() => (columns), [])

    return (
        <BodyCard style={{ flex: 1 }}>
            <StandardCardLayout>
                <StandardCardHeader
                    title="Email Templates"
                    subtitle="Manage system email templates"
                />
                <StandardCardGridContainer>
                    <Grid
                        columns={memoizedColumns}
                        rows={emailTemplates}
                        pagination={pagination}
                        onPaginationChange={onPaginationChange}
                        totalCount={totalCount}
                    />
                </StandardCardGridContainer>
            </StandardCardLayout>
        </BodyCard>
    )
}

export const AdminEmailTemplatesGridCardLoadingState: FC = () => {
    return (
        <BodyCard style={{ flex: 1 }}>
            <StandardCardLayout>
                <StandardCardHeaderLoadingState
                    hasSubtitle={true}
                />
                <GridLoadingState />
            </StandardCardLayout>
        </BodyCard>
    )
}